import React from 'react'
import { useTranslation } from 'next-i18next'
import { Link } from 'react-router-dom'
import './LegalPages.scss'

/**
 * Terms of Service page component
 * Displays the complete terms and conditions for the ticket purchasing service
 */
const TermsOfService = () => {
  const { t } = useTranslation()

  return (
    <div className="legal-page">
      <div className="container">
        <div className="legal-content">
          <h1>{t('legal.terms.title')}</h1>
          <p className="last-updated">{t('legal.terms.lastUpdated', { date: '15 de enero de 2025' })}</p>

          <section>
            <h2>1. Aceptación de los Términos</h2>
            <p>
              Al acceder y utilizar el servicio de venta de entradas de PianoMeetups ("el Servicio"), 
              usted acepta estar sujeto a estos Términos de Servicio ("Términos"). Si no está de acuerdo 
              con alguna parte de estos términos, no debe utilizar nuestro servicio.
            </p>
          </section>

          <section>
            <h2>2. Descripción del Servicio</h2>
            <p>
              PianoMeetups es una asociación sin ánimo de lucro que organiza eventos musicales y ofrece un servicio de 
              venta de entradas en línea. Facilitamos la compra de entradas para eventos de piano y 
              música en general organizados por nuestra comunidad.
            </p>
          </section>

          <section>
            <h2>3. Compra de Entradas</h2>
            <h3>3.1 Proceso de Compra</h3>
            <ul>
              <li>Las entradas se venden por orden de llegada hasta agotar existencias</li>
              <li>Los precios pueden variar según la fecha de compra (precio anticipado vs. precio regular)</li>
              <li>Todas las compras deben completarse con un método de pago válido</li>
              <li>Se requiere verificación de email para completar la compra</li>
            </ul>

            <h3>3.2 Confirmación</h3>
            <p>
              Una vez completado el pago, recibirá una confirmación por email con sus entradas en formato PDF. 
              Es su responsabilidad conservar estas entradas para el acceso al evento.
            </p>
          </section>

          <section>
            <h2>4. Política de Cancelación y Reembolsos</h2>
            <h3>4.1 Cancelaciones por parte del Cliente</h3>
            <ul>
              <li>Las cancelaciones deben solicitarse al menos 72 horas antes del evento</li>
              <li>Se aplicará una tarifa de procesamiento del 10% sobre el valor de la entrada</li>
              <li>No se permiten cancelaciones dentro de las 72 horas previas al evento</li>
            </ul>

            <h3>4.2 Cancelaciones por parte del Organizador</h3>
            <p>
              En caso de cancelación del evento por parte del organizador, se ofrecerá reembolso completo 
              o transferencia a otro evento, según la preferencia del cliente.
            </p>
          </section>

          <section>
            <h2>5. Comportamiento en los Eventos</h2>
            <p>
              Los asistentes deben mantener un comportamiento respetuoso durante los eventos. 
              Nos reservamos el derecho de expulsar a cualquier persona que perturbe el evento 
              sin derecho a reembolso.
            </p>
          </section>

          <section>
            <h2>6. Propiedad Intelectual</h2>
            <p>
              Todo el contenido del sitio web, incluyendo textos, imágenes, logos y diseños, 
              está protegido por derechos de autor y es propiedad de PianoMeetups o sus licenciantes.
            </p>
          </section>

          <section>
            <h2>7. Limitación de Responsabilidad</h2>
            <p>
              PianoMeetups no será responsable por daños indirectos, incidentales o consecuentes 
              que puedan surgir del uso de nuestro servicio o la asistencia a nuestros eventos, 
              más allá del valor de la entrada adquirida.
            </p>
          </section>

          <section>
            <h2>8. Protección de Datos</h2>
            <p>
              El tratamiento de sus datos personales se rige por nuestra Política de Privacidad, 
              que forma parte integral de estos Términos de Servicio.
            </p>
          </section>

          <section>
            <h2>9. Modificaciones</h2>
            <p>
              Nos reservamos el derecho de modificar estos términos en cualquier momento. 
              Las modificaciones entrarán en vigor inmediatamente después de su publicación 
              en nuestro sitio web.
            </p>
          </section>

          <section>
            <h2>10. Ley Aplicable</h2>
            <p>
              Estos términos se rigen por las leyes de España. Cualquier disputa será resuelta 
              en los tribunales competentes de Madrid, España.
            </p>
          </section>

          <section>
            <h2>11. Contacto</h2>
            <p>
              Para cualquier consulta sobre estos Términos de Servicio, puede contactarnos en:
            </p>
            <ul>
              <li>Email: info@pianomeetups.com</li>
              <li>Contacto: 605876147</li>
            </ul>
          </section>

          <div style={{ textAlign: 'center', marginTop: '2rem', paddingTop: '2rem', borderTop: '1px solid #dee2e6' }}>
            <Link to="/" className="btn btn-primary">
              {t('legal.terms.backToHome')}
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TermsOfService